/**
 * @desc performs the given action on the next render tick
 * @param {function} callback - the callback function to perform on next tick (next render)
 */
export const onNextTick = callback => setTimeout(callback, 0);
